export default {
  name: 'NEOS',
  versions: ['neos/neos_1.jpg', 'neos/neos_2.jpg', 'neos/neos_3.jpg'],
  baseStyle: {
    fontFamily: '"Montserrat", "Gotham Narrow", "Open Sans", sans-serif',
    letterSpacing: '1px',
    textAlign: 'center',
    display: 'block',
    position: 'relative',
    lineHeight: '1.2',
    marginTop: '5px',
    marginBottom: '5px',
    textTransform: 'uppercase'
  },
  containerStyle: {
    paddingBottom: '15%',
    paddingRight: '10%',
    paddingLeft: '10%',
    textAlign: 'center'
  },
  customStyles: [
    {
      name: "pink",
      style: {
        color: '#FFF',
        boxShadow: '10px 0 0 #e84189, -10px 0 0 #e84189',
        display: 'inline',
        backgroundColor: '#e84189',
      }
    },
    {
      name: "gelb",
      style: {

        color: '#e84189',
        boxShadow: '10px 0 0 #FCEB00, -10px 0 0 #FCEB00',
        display: 'inline',
        backgroundColor: '#FCEB00',
        transform: 'rotate(-5deg)',
        maxWidth: '70%'
      }
    }
  ],
  linesDefault: [
    {
      text: 'Durch die pinke Brille schaun',
      style: 0,
      fontSize: 70
    },
    {
      text: 'Weil eh schon ois wurscht is',
      style: 1,
      fontSize: 45
    }
  ]
}




// WEBPACK FOOTER //
// ./src/config/neos.js